import { Head } from "@inertiajs/react"
import { AppLayout } from "../../components/layout/AppLayout"
import { ClientForm } from "../../features/clients/ClientForm"

type EditClientPageProps = {
  client: {
    id: number
    cliente: string
    cpf_cnpj_tomador: string
    inscricao_municipal_tomador: string
    inscricao_estadual_tomador: string
    razao_social_tomador: string
    tipo_endereco_tomador: string
    endereco_tomador: string
    numero_endereco_tomador: string
    complemento_endereco_tomador: string
    bairro_tomador: string
    cidade_tomador: string
    uf_tomador: string
    cep_tomador: string
    exterior: boolean
    codigo_sap?: string | null
    cr?: string | null
    omie_n_cod_cli?: string
  }
  errors?: Record<string, string[]>
}

export default function EditClientPage({ client, errors }: EditClientPageProps) {
  return (
    <>
      <Head title="Editar Cliente" />
      <AppLayout>
        <div className="mx-auto w-full max-w-6xl p-8">
          <div className="mb-6">
            <h1 className="text-3xl font-bold text-white">Editar Cliente</h1>
            <p className="text-slate-400">Atualize os dados do cliente.</p>
          </div>
          <ClientForm
            initialValues={client}
            submitUrl={`/clientes/${client.id}`}
            submitLabel="Salvar alterações"
            method="patch"
            errors={errors}
          />
        </div>
      </AppLayout>
    </>
  )
}
